import React, { useState, useEffect } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/global/layout';
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import { Tooltip } from 'antd';
import environment from '../../environment';

const AddEditFeature = () => {
  const [images, setImages] = useState({ image: '', banner: '', icon: '' });
  const [features, setFeatures] = useState([{ name: '' }]);
  const [data, setdata] = useState([]);

  const { id } = useParams();
  const [form, setform] = useState({ id: '', name: '' });
  const history = useNavigate();
  const [num, setnum] = useState(1);

  const [submitted, setSubmitted] = useState(false);
  const [categories, setcategories] = useState();
  const user = useSelector((state) => state.user);
  // const formValidation = [
  //     { key: 'status', required: true },
  // ]

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // let invalid = methodModel.getFormError(formValidation, form)
    // if (invalid) return
    let method = 'post';
    let url = 'feature';
    let value = { name: features };
    if (id) {
      method = 'put';
      url = 'feature';
      value = { name: features[0]?.name, id: JSON.parse(features[0]?.id) };
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history('/features');
      }
      loader(false);
    });
  };

  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get(`feature?id=${id}`).then((res) => {
        if (res.success) {
          let value = res.data;

          setFeatures([{ name: res?.data?.name, id: res?.data?.id }]);
        }
        loader(false);
      });
    }
  }, [id]);

  const onSelect = (e) => {
    console.log('onSelect', e);
  };

  const onRemove = (e) => {
    console.log('onRemove', e);
  };

  const getCategoires = () => {
    ApiClient.get(`api/categorie/list`, {
      catType: environment.planTypeId,
      status: 'active',
    }).then((res) => {
      setcategories(res.data);
    });
  };
  const updatetag = (index, key, value) => {
    let arr = features;
    arr[index][key] = value;
    console.log(arr, key, value, index);
    setFeatures([...arr]);
    setform({
      ...form,
      features: [...arr],
    });
    setnum(arr.length);
  };

  const removetag = (index) => {
    setFeatures([...features.filter((itm, i) => i != index)]);
    setform({
      ...form,
      setFeatures: [...features.filter((itm, i) => i != index)],
    });

    setnum(num - 1);
  };

  const AddTag = () => {
    features.push({
      name: '',
    });
    setFeatures([...features]);
  };
  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link
                  to="/features"
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'} Plan Feature
                </h3>
              </div>
            </div>
            <div className=" white-bg-main mb-4">
              <div className=" white-head mb-3 d-flex justify-content-between align-items-center"></div>
              <label>
                Features<span className="star">*</span>
              </label>
              <div className="box_shadow grid grid-cols-12 gap-4 border-none p-4 rounded-md bg-[#a7a7a745]">
                {features.map((itm, i) => {
                  return (
                    <div
                      className={`${
                        features?.length === 1 ? 'col-span-12' : 'col-span-6'
                      }`}
                      onChange={(e) => {
                        if (num > data[0]?.sizeOfVenue) {
                          removetag(i);
                        }
                      }}
                    >
                      <div className="flex items-center relative">
                        <input
                          type="text"
                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2 pr-12"
                          value={itm?.name}
                          onChange={
                            (e) => updatetag(i, 'name', e.target.value)
                            // setform({ ...form, name: e.target.value })
                          }
                          required
                        />

                        {!id ? (
                          <i
                            className="fa fa-trash text-danger pointer flex justify-center items-center w-[40px] h-[40px] border-l-[1px] border-[#e5e7ea] rounded-lg  right-0 absolute"
                            onClick={(e) => removetag(i)}
                          ></i>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
              {!id ? (
                <div>
                  <button
                    type="button"
                    className="btn btn-primary mt-3"
                    onClick={AddTag}
                  >
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add
                    Feature
                  </button>
                </div>
              ) : null}
            </div>
            {/* <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6">
                <label>
                  Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form.name}
                  onChange={(e) => setform({ ...form, name: e.target.value })}
                  required
                />
              </div>
          
            </div> */}

            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditFeature;
